
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "COBPL",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/COBPL.vue